import Alert from './Alert';
export default {
    install: function (Vue) {
        Vue.component('Alert', Alert);
    }
}


// WEBPACK FOOTER //
// ./src/mix.js